import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["format-key", "href", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createBlock(_component_checkbox_field, {
    "model-value": $props.modelValue,
    class: "_mt-3",
    condensed: true,
    "display-name": $options.refundAndCancellationPolicyFieldName,
    "label-class": "_flex",
    name: $props.name,
    "onUpdate:modelValue": $options.onInput,
    "data-qa": "crowdfunding-terms-agreement"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_localize, { resource: $options.termsAndConditionsResource }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.termsAndConditionsLinks, (link, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link.dataQa,
              "format-key": index.toString(),
              href: link.url,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "gfu-link gfu-link--accent",
              "data-qa": link.dataQa
            }, _toDisplayString(link.label), 9 /* TEXT, PROPS */, _hoisted_1))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["resource"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model-value", "display-name", "name", "onUpdate:modelValue"]))
}